import { useState, useEffect } from 'react';
import { Calendar } from 'lucide-react';
const CurrentDate = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000 * 60 * 60); // Update every hour

    return () => clearInterval(timer);
  }, []);
  const formatDate = (date: Date) => {
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    };
    return date.toLocaleDateString('en-US', options);
  };
  return (
    <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground mb-4">
      <Calendar size={16} />
      <time>{formatDate(currentDate)}</time>
    </div>
  );
};
export default CurrentDate;